<template>
    <div :class="[$style.info_block, isDesktopFooter && $style.info_block_desktop_footer]">
        <img
            v-if="!props.unavailable && !props.disabledIcon"
            :class="[
                'sqrcl',
                $style.image,
                props.game ? $style.visible : $style.hidden,
                isDesktopFooter && $style.image_desktop_footer,
                props.limitedAvailability && $style.darken_filter,
            ]"
            :src="props.game?.icon"
            :alt="props.game?.title"
        />
        <div
            v-else
            :class="[$style.image, $style.unavailable_image, isDesktopFooter && $style.image_desktop_footer]"
        />
        <div :class="[$style.title_wrapper, props.limitedAvailability && $style.darken_filter]">
            <Typography
                :type="props.unavailable ? 'caption' : 'label'"
                size="m"
                semibold
                :responsive="false"
                :class="props.unavailable ? $style.title_unavailable : $style.title"
            >
                {{ topText }}
            </Typography>
            <Typography
                v-if="props.unavailable"
                type="label"
                size="xs"
                :responsive="false"
                :class="$style.description"
            >
                <!-- eslint-disable vue/no-v-html -->
                <p v-html="tr('unavailableGame.description')" />
            </Typography>
            <!-- eslint-disable vue/no-v-html -->
            <Typography
                v-else-if="category"
                type="caption"
                size="m"
                :responsive="false"
                :class="$style.category"
            >
                {{ props.category || '' }}
            </Typography>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import Typography from '@/components/Typography.vue'
import { useTr } from '@/composables/use-tr'
import type { APIGameType } from '@/types'

const props = defineProps<{
    game?: APIGameType
    category?: string
    placement?: 'desktop_footer' | 'init_screen' | 'mobile_game_container'
    unavailable?: boolean
    disabledIcon?: boolean
    limitedAvailability?: boolean
}>()

const tr = useTr()

const topText = computed(() => {
    if (props.unavailable) {
        return tr('unavailableGame.oops')
    }
    return props.game
        ? `${props.game?.title}${props.placement === 'init_screen' && props.game?.gameUrlRedirectTarget ? ' *' : ''}`
        : ''
})

const isDesktopFooter = computed(() => props.placement === 'desktop_footer')
</script>

<style module>
.visible {
    opacity: 1;
}

.hidden {
    opacity: 0;
}

.info_block {
    overflow: hidden;
    display: flex;
    min-width: 0;
    max-width: 100%;
    height: 48px;
    gap: 8px;
}

.image {
    width: 48px;
    height: 48px;
    object-fit: cover;
    border-radius: 12px;
    --sqrcl: 24px;
}

.info_block_desktop_footer {
    height: 40px;
}

.image_desktop_footer {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    --sqrcl: 16px;
}

.darken_filter {
    filter: grayscale(100%) brightness(65%);
}

.unavailable_image {
    background-color: var(--white-16);
}

.title_wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2px;
    flex-shrink: 1;
    min-width: 0;
}

.title,
.category,
.description {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.title_unavailable {
    margin-top: -4px;
    margin-bottom: -2px;
}

.category,
.description {
    color: var(--white-40);
}
</style>
